"use client";

import { StoryblokComponent, useStoryblokState } from "@storyblok/react";
import YouTubePlaylist from "@/components/YouTubePlaylist";
import { sbBlok } from "@/types/sb-types";

type Props = {
  story: any;
  videos: any;
  videosTemplate: number;
  totalVideosCount: number;
  currentPage: number;
};

type StoryContent = {
  body?: sbBlok[];
  [key: string]: any;
};

type StoryState = {
  content?: StoryContent;
  [key: string]: any;
};

export default function HighlightsClient({
  story,
  videos,
  videosTemplate,
  totalVideosCount,
  currentPage,
}: Props) {
  const storyState = useStoryblokState(story) as StoryState;

  return (
    <>
      {storyState?.content?.body?.map((c: sbBlok) => {
        if (c.component === "youtube_playlist" && videos?.length > 0) {
          return (
            <YouTubePlaylist
              key={c._uid}
              videos={videos}
              videosTemplate={videosTemplate}
              totalVideosCount={totalVideosCount}
              pageParam={currentPage}
            />
          );
        }
        return <StoryblokComponent key={c._uid} blok={c} />;
      })}
    </>
  );
}
